import {
  createAmount,
} from '@dapi/sdk/spec';
import {
  refundMethodOptionsByTravelDocumentId,
} from '../dictionaries';
import {
  taxTemplate,
} from './mock-tax';

export const getOrderEligibilitiesMockEligibleToRefundOnCcAndPaypal = {
  warnings: [
    {
      code: '39449',
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'Q3EAEY',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '1172457148333',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148333', 'SEK', 12_361, 2000)
        },
        {
          travelDocumentId: '1172457148334',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148334', 'SEK', 12_361, 2000)
        },
        {
          travelDocumentId: '1172457148335',
          documentType: 'eticket',
          travelerIds: [
            'PT3'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 9445,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 11_213,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148335', 'SEK', 9213, 2000)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundOnUnknownPaymentMethod = {
  warnings: [
    {
      code: '39449',
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'Q3EAEY',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '1172457148333',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148333', 'SEK', 12_361, 0, 0, 2000)
        },
        {
          travelDocumentId: '1172457148334',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148334', 'SEK', 12_361, 0, 0, 2000)
        },
        {
          travelDocumentId: '1172457148335',
          documentType: 'eticket',
          travelerIds: [
            'PT3'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 9445,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 11_213,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148335', 'SEK', 9213, 0, 0, 2000)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundOnPaypalAndOnlineBanking = {
  warnings: [
    {
      code: '39449',
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'Q3EAEY',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '1172457148333',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148333', 'SEK', 0, 12_361, 2000)
        },
        {
          travelDocumentId: '1172457148334',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148334', 'SEK', 0, 12_361, 2000)
        },
        {
          travelDocumentId: '1172457148335',
          documentType: 'eticket',
          travelerIds: [
            'PT3'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 9445,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 11_213,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148335', 'SEK', 0, 9213, 2000)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundWithServices = {
  warnings: [
    {
      code: 39_449,
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'K26CZX',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: 1_722_400_159_180,
          documentType: 'eticket',
          travelerIds: ['PT2'],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            },
            total: {
              value: 16_110,
              currencyCode: 'EUR'
            }
          },
          penalty: {
            value: 10_000,
            currencyCode: 'EUR'
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1722400159180', 'EUR', 16_110)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundWithoutServices = {
  data: {
    orderId: 'Q3EAEY',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '1172457148333',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148333', 'SEK', 14_361)
        },
        {
          travelDocumentId: '1172457148334',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148334', 'SEK', 14_361)
        },
        {
          travelDocumentId: '1172457148335',
          documentType: 'eticket',
          travelerIds: [
            'PT3'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 9445,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 11_213,
              currencyCode: 'SEK'
            }
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1172457148335', 'SEK', 11_213)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundWithInsurances = {
  warnings: [
    {
      code: 39_450,
      title: 'YOUR INSURANCE WILL NOT BE REFUNDED',
      detail: 'Insurance are not refundable'
    }
  ],
  data: {
    orderId: 'K26CZX',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: 1_722_400_159_180,
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            },
            total: {
              value: 16_110,
              currencyCode: 'EUR'
            }
          },
          penalty: {
            value: 10_000,
            currencyCode: 'EUR'
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1722400159180', 'EUR', 16_110)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundWithInsurancesAndServices = {
  warnings: [
    {
      code: 39_449,
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    },
    {
      code: 39_450,
      title: 'YOUR INSURANCE WILL NOT BE REFUNDED',
      detail: 'Insurance are not refundable'
    }
  ],
  data: {
    orderId: 'K26CZX',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: 1_722_400_159_180,
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            },
            total: {
              value: 16_110,
              currencyCode: 'EUR'
            }
          },
          penalty: {
            value: 10_000,
            currencyCode: 'EUR'
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('1722400159180', 'EUR', 16_110)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundOnVoucher = {
  data: {
    orderId: 'ABC123',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '1722400059162',
          documentType: 'eticket',
          travelerIds: ['PT2'],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 18_300,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 1184,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1520,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 3367,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 4800,
                currencyCode: 'EUR',
                code: 'YQ'
              }
            ],
            totalTaxes: {
              value: 10_871,
              currencyCode: 'EUR'
            },
            total: {
              value: 29_171,
              currencyCode: 'EUR'
            }
          },
          paidAmount: {
            base: {
              value: 18_300,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 1184,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1520,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 3367,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 4800,
                currencyCode: 'EUR',
                code: 'YQ'
              }
            ]
          },
          usedAmount: {
            base: {
              value: 0,
              currencyCode: 'EUR'
            }
          },
          refundMethodOptions: [
            {
              id: '1722400059162-DEFAULT',
              paymentDetails: [
                {
                  paymentMethod: {
                    paymentType: 'PaymentCard',
                    vendorCode: 'CA',
                    cardNumber: 'XXXXXXXXXXXX0009'
                  },
                  amount: {
                    value: 29_171,
                    currencyCode: 'EUR'
                  }
                }
              ]
            },
            {
              id: '1722400059162-VOUCHER',
              paymentDetails: [
                {
                  paymentMethod: {
                    paymentType: 'VoucherPayment'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToManualRefund = {
  warnings: [
    {
      code: '39449',
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'Q3EAEY',
    cancelAndRefund: {
      refundStatus: 'manuallyRefundable',
      refundOptions: [
        {
          travelDocumentId: '1172457148333',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          }
        },
        {
          travelDocumentId: '1172457148334',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 12_593,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 14_361,
              currencyCode: 'SEK'
            }
          }
        },
        {
          travelDocumentId: '1172457148335',
          documentType: 'eticket',
          travelerIds: [
            'PT3'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 9445,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 1768,
              currencyCode: 'SEK'
            },
            total: {
              value: 11_213,
              currencyCode: 'SEK'
            }
          }
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const getOrderEligibilitiesMockDisruptedOutboundManuallyRefundable = {
  warnings: [
    {
      code: '39449',
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'TBEVQ7',
    cancelAndRefund: {
      refundStatus: 'manuallyRefundable',
      refundOptions: [
        {
          travelDocumentId: '1052467303580',
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundType: 'involuntary',
          refundAmounts: {
            base: {
              value: 48_400,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 17_548,
              currencyCode: 'EUR'
            },
            total: {
              value: 65_948,
              currencyCode: 'EUR'
            }
          }
        },
        {
          travelDocumentId: '1052467303579',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundType: 'involuntary',
          refundAmounts: {
            base: {
              value: 36_300,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 16_338,
              currencyCode: 'EUR'
            },
            total: {
              value: 52_638,
              currencyCode: 'EUR'
            }
          }
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToRefundWithServicesAndDetailledAmounts = {
  warnings: [
    {
      code: 39_449,
      title: 'YOUR SERVICES WILL NOT BE REFUNDED',
      detail: 'Services are not refundable'
    }
  ],
  data: {
    orderId: 'OQJTFY',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: 2_202_462_234_880,
          documentType: 'eticket',
          travelerIds: [
            'PT1'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 0,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 1182,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1533,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 2673,
                currencyCode: 'EUR',
                code: 'RD'
              }
            ],
            totalTaxes: {
              value: 5388,
              currencyCode: 'EUR'
            },
            total: {
              value: 5388,
              currencyCode: 'EUR'
            }
          },
          paidAmount: {
            base: {
              value: 16_000,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 1184,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1533,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 3220,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 4500,
                currencyCode: 'EUR',
                code: 'YQ'
              },
              {
                value: 1182,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1533,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 2673,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 900,
                currencyCode: 'EUR',
                code: 'YQ'
              },
              {
                value: 1000,
                currencyCode: 'EUR',
                code: 'YQ'
              }
            ]
          },
          usedAmount: {
            base: {
              value: 16_000,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 1184,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 1533,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 3220,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 4500,
                currencyCode: 'EUR',
                code: 'YQ'
              }
            ]
          },
          penalty: {
            value: 5000,
            currencyCode: 'EUR'
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('2202462234880', 'EUR', 5388)
        },
        {
          travelDocumentId: 2_202_462_234_881,
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: {
              value: 0,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 2366,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 3066,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 5893,
                currencyCode: 'EUR',
                code: 'RD'
              }
            ],
            totalTaxes: {
              value: 11_325,
              currencyCode: 'EUR'
            },
            total: {
              value: 11_325,
              currencyCode: 'EUR'
            }
          },
          paidAmount: {
            base: {
              value: 12_000,
              currencyCode: 'EUR'
            },
            taxes: [
              {
                value: 2366,
                currencyCode: 'EUR',
                code: 'DE'
              },
              {
                value: 3066,
                currencyCode: 'EUR',
                code: 'OY'
              },
              {
                value: 5893,
                currencyCode: 'EUR',
                code: 'RD'
              },
              {
                value: 5400,
                currencyCode: 'EUR',
                code: 'YQ'
              }
            ]
          },
          usedAmount: {
            base: {
              value: 12_000,
              currencyCode: 'EUR'
            }
          },
          penalty: {
            value: 5000,
            currencyCode: 'EUR'
          },
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('2202462234881', 'EUR', 11_325)
        }
      ]
    }
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const getOrderEligibilitiesMockEligibleToVoluntaryRefund = {
  data: {
    orderId: 'TBEVQ7',
    cancelAndRefund: {
      refundStatus: 'refundable',
      refundOptions: [
        {
          travelDocumentId: '9562400002065',
          documentType: 'eticket',
          travelerIds: [
            'PT2'
          ],
          status: 'refundable',
          refundAmounts: {
            base: createAmount({
              template: {
                value: 45_700
              }
            }),
            taxes: [
              {
                ...taxTemplate,
                value: 473,
                code: 'FR'
              },
              {
                ...taxTemplate,
                value: 820,
                code: 'FR'
              },
              {
                ...taxTemplate,
                value: 1127,
                code: 'IZ'
              },
              {
                ...taxTemplate,
                value: 900,
                code: 'O4'
              },
              {
                ...taxTemplate,
                value: 637,
                code: 'QW'
              }
            ],
            totalTaxes: createAmount({
              template: {
                value: 3957
              }
            }),
            total: createAmount({
              template: {
                value: 45_057
              }
            })
          },
          paidAmount: {
            base: createAmount({
              template: {
                value: 45_700
              }
            }),
            taxes: [
              {
                ...taxTemplate,
                value: 473,
                code: 'FR'
              },
              {
                ...taxTemplate,
                value: 820,
                code: 'FR'
              },
              {
                ...taxTemplate,
                value: 1127,
                code: 'IZ'
              },
              {
                ...taxTemplate,
                value: 900,
                code: 'O4'
              },
              {
                ...taxTemplate,
                value: 637,
                code: 'QW'
              }
            ]
          },
          usedAmount: {
            base: createAmount({
              template: {
                value: 0
              }
            })
          },
          penalty: createAmount({
            template: {
              value: 4600
            }
          }),
          refundMethodOptions: refundMethodOptionsByTravelDocumentId('9562400002065', 'EUR', 45_057)
        }
      ]
    }
  }
};
